import { api } from '@/utils/apiService';
import { DEAL_TEMPLATES } from '@/utils/dealBadge';

const dealTemplate = {
  namespaced: true,
  state: {
    templates: [...DEAL_TEMPLATES],
    loaded: false,
    loading: false,
  },
  getters: {
    activeTemplates: (state) => state.templates.filter((t) => t.active !== false),
    getTemplates: (state) => state.templates,
  },
  mutations: {
    SET_TEMPLATES(state, templates) {
      state.templates = templates.length ? templates : [...DEAL_TEMPLATES];
      state.loaded = true;
      state.loading = false;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTemplates({ commit, state }) {
      if (state.loading) return;
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/deal-template');
        commit('SET_TEMPLATES', response.data || []);
      } catch (error) {
        console.error('fetchTemplates failed', error);
        commit('SET_TEMPLATES', state.templates.length ? state.templates : [...DEAL_TEMPLATES]);
      }
    },
  },
};

export default dealTemplate;
